import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { actionKey } from './constants';
import { uploadFile, uploadFiles, uploadProgress, uploadSuccess, uploadFailure, uploadFileImmediately, cancelFileUpload, removeErroredUpload } from './actions';
import { handleActions } from 'redux-actions';
const defaultState = {
    fileUploads: [],
    fileUploadsWaiting: []
};
const actionHandlers = handleActions({
    [uploadFile.toString()]: (state, { payload  })=>_object_spread_props(_object_spread({}, state), {
            fileUploadsWaiting: [
                ...state.fileUploadsWaiting,
                _object_spread({}, payload)
            ]
        }),
    [uploadFiles.toString()]: (state, { payload  })=>_object_spread_props(_object_spread({}, state), {
            fileUploadsWaiting: [
                ...state.fileUploadsWaiting,
                ...payload.files
            ]
        }),
    [uploadFileImmediately.toString()]: (state, { payload  })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: [
                ...state.fileUploads,
                _object_spread({}, payload)
            ],
            fileUploadsWaiting: state.fileUploadsWaiting.filter((f)=>f.fileId !== payload.fileId)
        }),
    [uploadFailure.toString()]: (state, { payload: { fileId , error  }  })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: [
                ...state.fileUploads
            ].map((item)=>item.fileId === fileId ? _object_spread_props(_object_spread({}, item), {
                    error
                }) : item)
        }),
    [uploadProgress.toString()]: (state, { payload: { fileId , progress  }  })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: [
                ...state.fileUploads
            ].map((item)=>item.fileId === fileId ? _object_spread_props(_object_spread({}, item), {
                    progress
                }) : item)
        }),
    [uploadSuccess.toString()]: (state, { payload  })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: state.fileUploads.filter((item)=>payload.fileId !== item.fileId)
        }),
    [removeErroredUpload.toString()]: (state, { payload: { fileId  }  })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: state.fileUploads.filter((item)=>!(item.fileId === fileId && item.error))
        }),
    [cancelFileUpload.toString()]: (state, { payload: { fileId  }  })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: state.fileUploads.filter((item)=>item.fileId !== fileId),
            fileUploadsWaiting: state.fileUploads.filter((item)=>item.fileId !== fileId)
        })
}, defaultState);
const reducers = {
    [actionKey]: actionHandlers
};
export default reducers;
